const CATCH_SELLER_ID = "1";

export const isSoldByCatch = (sellerId) => sellerId == CATCH_SELLER_ID;
